namespace Matrix.Data {
    export interface DataDictionaryRow {
        Id?: string;
        TableSchema?: string;
        MxTableName?: string;
        AliasView?: string;
        ColumnName?: string;
        Alias?: string;
        Description?: string;
        IsSystemColumn?: string;
        OrdinalPosition?: number;
        ColumnDefault?: string;
        IsNullable?: string;
        DataType?: string;
        CharacterMaximumLength?: number;
        CharacterOctetLength?: number;
        NumericPrecision?: number;
        NumericPrecisionRadix?: number;
        NumericScale?: number;
        DatetimePrecision?: number;
        CharacterSetCatalog?: string;
        CharacterSetSchema?: string;
        CharacterSetName?: string;
        CollationCatalog?: string;
        CollationSchema?: string;
        CollationName?: string;
        DomainCatalog?: string;
        DomainSchema?: string;
        DomainName?: string;
    }

    export namespace DataDictionaryRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'Data.DataDictionary';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            TableSchema = "TableSchema",
            MxTableName = "MxTableName",
            AliasView = "AliasView",
            ColumnName = "ColumnName",
            Alias = "Alias",
            Description = "Description",
            IsSystemColumn = "IsSystemColumn",
            OrdinalPosition = "OrdinalPosition",
            ColumnDefault = "ColumnDefault",
            IsNullable = "IsNullable",
            DataType = "DataType",
            CharacterMaximumLength = "CharacterMaximumLength",
            CharacterOctetLength = "CharacterOctetLength",
            NumericPrecision = "NumericPrecision",
            NumericPrecisionRadix = "NumericPrecisionRadix",
            NumericScale = "NumericScale",
            DatetimePrecision = "DatetimePrecision",
            CharacterSetCatalog = "CharacterSetCatalog",
            CharacterSetSchema = "CharacterSetSchema",
            CharacterSetName = "CharacterSetName",
            CollationCatalog = "CollationCatalog",
            CollationSchema = "CollationSchema",
            CollationName = "CollationName",
            DomainCatalog = "DomainCatalog",
            DomainSchema = "DomainSchema",
            DomainName = "DomainName"
        }
    }
}
